import { render, staticRenderFns } from "./RecipientSelect.vue?vue&type=template&id=4c9bfdd4&scoped=true"
import script from "./RecipientSelect.vue?vue&type=script&lang=js"
export * from "./RecipientSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9bfdd4",
  null
  
)

export default component.exports